module.exports = __webpack_public_path__ + "img/flick-hand.b3bec547.svg";